// extracted by mini-css-extract-plugin
export default {"bannerLeft":"Slider2_bannerLeft__FSO7Y","bannerVideo":"Slider2_bannerVideo__MFIGG"};